import React, { useState } from "react";
import WizardPageWrapper, { GeneralPageSummary } from "../WizardPageWrapper";
import { Checkbox, Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { UploadFile } from "antd/lib/upload/interface";
import Flex from "../../../../../../components/Flex";
import FileDropzone from "../FileDropzone";
import { CoverWizardForm } from "../../CoverWizardModal";
import ConfirmationModal from "../../../../../../components/ConfirmationModal";

type AttachFilesPageProps = {
  wizardPageNumberState: [number, React.Dispatch<React.SetStateAction<number>>];
  onNextButtonClick?: () => void;
  onBackButtonClick?: () => void;
  hideBackButton?: boolean;
  submitOnNext?: boolean;
  formIsSubmitting?: boolean;
  advancedFlowEnabled?: boolean;
  summary?: React.ReactNode;
  title?: string;
};

const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e?.fileList;
};

const allowedFileExtensions: string[] = [];

const fileUploaderName = "fileList";

export default function AttachFilesPage({
  submitOnNext,
  onNextButtonClick,
  onBackButtonClick,
  hideBackButton = false,
  formIsSubmitting = false,
  wizardPageNumberState: [wizardPhase, setWizardPhase],
  advancedFlowEnabled,
  summary = <GeneralPageSummary />,
  title = "Supply Pool Specs",
}: AttachFilesPageProps) {
  useState<UploadFile>();
  const [proceedWithWizardModalIsOpen, setProceedWithWizardModalIsOpen] =
    useState<boolean>(false);

  const form = Form.useFormInstance<CoverWizardForm>();

  const fileList = Form.useWatch("fileList", { preserve: true, form }) ?? [];

  const comments = Form.useWatch("comments", { preserve: true, form }) ?? "";

  return (
    <>
      <WizardPageWrapper
        title={title}
        summary={summary}
        submitOnNext={advancedFlowEnabled ? false : true}
        disablePrevious={formIsSubmitting}
        onNextButtonClick={() => form.submit()
        }
        onBackButtonClick={() =>
          !!onBackButtonClick ? onBackButtonClick() : setWizardPhase(1)
        }
        disableNext={(!fileList.length && !comments) || formIsSubmitting}
        nextIsLoading={formIsSubmitting}
        nextButtonText="Submit"
        hideBackButton={hideBackButton}
      >
        <Flex vertical gap="16px">
          <Flex vertical gap="8px">
            <Flex vertical gap="4px">
              <Form.Item<CoverWizardForm>
                label={`If you have any drawings, photos, or other files, attach them here${
                  !!comments || !!fileList.length ? "" : "*"
                }`}
                className="pool-cover-quote-dragger-form-item"
                getValueFromEvent={normFile}
                name={fileUploaderName}
              >
                <FileDropzone
                  allowedFileExtensions={allowedFileExtensions}
                  fileList={fileList}
                  disabled={formIsSubmitting}
                  onChange={(files) => {
                    form.setFieldValue(fileUploaderName, files);
                  }}
                  deleteFile={(file) => {
                    const filesToSave = fileList.filter(
                      (x) => x.uid !== file.uid
                    );
                    form.setFieldValue(fileUploaderName, filesToSave);
                  }}
                />
              </Form.Item>
            </Flex>
          </Flex>
          <Form.Item<CoverWizardForm>
            style={{ margin: "0" }}
            name="comments"
            label="Comments/Instructions"
            colon={false}
            rules={[
              {
                required: !fileList.length && !comments,
                message: "A file or comment is required.",
              },
            ]}
          >
            <TextArea
              rows={4}
              disabled={formIsSubmitting}
              style={{ resize: "none", borderRadius: "8px" }}
              placeholder="Additional comments or instructions"
            />
          </Form.Item>
          {/* <Form.Item<CoverWizardForm>
            valuePropName="checked"
            style={{ margin: "0" }}
            name="useMeasuringServices"
          >
            <Checkbox disabled>
              Measure my pool with Meyco Measuring Services
            </Checkbox>
          </Form.Item> */}
        </Flex>
      </WizardPageWrapper>
      <ConfirmationModal
        headerText="Thank You!"
        bodyText="That's the basics done, you can stop here or continue on to complete the order form manually"
        proceedButtonText="Continue to complete the order form"
        cancelButtonText="Quit"
        cancelButtonType="primary"
        proceedButtonType="default"
        onProceed={() => onNextButtonClick?.()}
        onCancel={() => form.submit()}
        modalIsOpenState={[
          proceedWithWizardModalIsOpen,
          setProceedWithWizardModalIsOpen,
        ]}
      />
    </>
  );
}
